 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import LOVE_1 from '@/components/love_1'
 import TEXTFM01 from '@/components/Text/fm01'
 import TEXTTITLE from '@/components/Text/title'
 import TEXTCOPYRIGHT from '@/components/Text/copyright'
 import TEXTDED from '@/components/Text/ded'
 import TEXTCONTENTS from '@/components/Text/contents'
 import TEXTFOREWORD from '@/components/Text/foreword'
 import TEXTINTRO from '@/components/Text/intro'
 import TEXTPART01 from '@/components/Text/part01'
 import TEXTCH01 from '@/components/Text/ch01'
 import TEXTCH02 from '@/components/Text/ch02'
 import TEXTCH03 from '@/components/Text/ch03'
 import TEXTCH04 from '@/components/Text/ch04'
 import TEXTCH05 from '@/components/Text/ch05'
 import TEXTCH06 from '@/components/Text/ch06'
 import TEXTCH07 from '@/components/Text/ch07'
 import TEXTPART02 from '@/components/Text/part02'
 import TEXTCH08 from '@/components/Text/ch08'
 import TEXTCH09 from '@/components/Text/ch09'
 import TEXTCH10 from '@/components/Text/ch10'
 import TEXTCH11 from '@/components/Text/ch11'
 import TEXTPART03 from '@/components/Text/part03'
 import TEXTCH12 from '@/components/Text/ch12'
 import TEXTCH13 from '@/components/Text/ch13'
 import TEXTPART04 from '@/components/Text/part04'
 import TEXTCH14 from '@/components/Text/ch14'
 import TEXTCH15 from '@/components/Text/ch15'
 import TEXTCH16 from '@/components/Text/ch16'
 import TEXTCH17 from '@/components/Text/ch17'
 import TEXTPART05 from '@/components/Text/part05'
 import TEXTCH18 from '@/components/Text/ch18'
 import TEXTCH19 from '@/components/Text/ch19'
 import TEXTCH20 from '@/components/Text/ch20'
 import TEXTPART06 from '@/components/Text/part06'
 import TEXTCH21 from '@/components/Text/ch21'
 import TEXTCH22 from '@/components/Text/ch22'
 import TEXTCH23 from '@/components/Text/ch23'
 import TEXTCH24 from '@/components/Text/ch24'
 import TEXTCH25 from '@/components/Text/ch25'
 import LOVE_2 from '@/components/love_2'
 import TEXTAFTER from '@/components/Text/after'
 import TEXTAPP01 from '@/components/Text/app01'
 import TEXTAPP02 from '@/components/Text/app02'
 import TEXTRINDEX from '@/components/Text/rindex'
 import TEXTINDEX from '@/components/Text/index'
 import TEXTAUTHOR from '@/components/Text/author'
 import TEXTPUB from '@/components/Text/pub'
 import TEXTBM01 from '@/components/Text/bm01'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/contents",
 			"name" : "Text/contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/foreword",
 			"name" : "Text/foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/intro",
 			"name" : "Text/intro",
 			"component" : TEXTINTRO
 		},
 		{
 			"path" : "/Text/part01",
 			"name" : "Text/part01",
 			"component" : TEXTPART01
 		},
 		{
 			"path" : "/Text/ch01",
 			"name" : "Text/ch01",
 			"component" : TEXTCH01
 		},
 		{
 			"path" : "/Text/ch02",
 			"name" : "Text/ch02",
 			"component" : TEXTCH02
 		},
 		{
 			"path" : "/Text/ch03",
 			"name" : "Text/ch03",
 			"component" : TEXTCH03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js